<div class="timepicker-container">
    <div class="d-flex justify-content-center align-items-center p-0 gap-2">
        <div class="hour-picker d-flex align-items-center flex-column">
            <button type="button" [disabled]="!canInc" (mousedown)="startHold('H_UP')"
                (touchstart.prevent)="startHold('H_UP')" (mouseup)="stopHold()" (mouseleave)="stopHold()"
                (touchend)="stopHold()" (touchcancel)="stopHold()">
                <img [src]="translationUrl + 'assets/images/arrow-down.svg'" style="transform: rotate(180deg);" />
            </button>

            <span>{{ hour === null ? '--' : hour.toString().padStart(2,'0') }}</span>

            <button type="button" [disabled]="!canDec" (mousedown)="startHold('H_DOWN')"
                (touchstart.prevent)="startHold('H_DOWN')" (mouseup)="stopHold()" (mouseleave)="stopHold()"
                (touchend)="stopHold()" (touchcancel)="stopHold()">
                <img [src]="translationUrl + 'assets/images/arrow-down.svg'" alt="arrow down">
            </button>
        </div>

        <div class="timepicker-separator">:</div>

        <div class="minute-picker d-flex align-items-center flex-column">
            <button type="button" [disabled]="!canInc" (mousedown)="startHold('M_UP')"
                (touchstart.prevent)="startHold('M_UP')" (mouseup)="stopHold()" (mouseleave)="stopHold()"
                (touchend)="stopHold()" (touchcancel)="stopHold()">
                <img [src]="translationUrl + 'assets/images/arrow-down.svg'" style="transform: rotate(180deg);" alt="arrow up">
            </button>

            <span>{{ minute === null ? '--' : minute.toString().padStart(2,'0') }}</span>

            <button type="button" [disabled]="!canDec" (mousedown)="startHold('M_DOWN')"
                (touchstart.prevent)="startHold('M_DOWN')" (mouseup)="stopHold()" (mouseleave)="stopHold()"
                (touchend)="stopHold()" (touchcancel)="stopHold()">
                <img [src]="translationUrl + 'assets/images/arrow-down.svg'" alt="arrow down">
            </button>
        </div>
    </div>

    <!-- Opcional: vista previa HH:mm -->
    <!-- <div class="mt-2 text-center">
        {{ formattedTime }}
    </div> -->
</div>